<slider-superior
  [ativo]="isSliderSuperior"
  [values]="arrSliderSuperior"
  [interval]="intervalSliderSuperior"
  [fontSize]="fontSizeSliderSuperior"
  [backgroundColor]="backgroundColorSliderSuperior"
>
</slider-superior>
<div id="gcc-header" class="shadow-sm" style="z-index: 99999 !important">
  <div>
    <div
      class="row align-items-center"
      style="padding-top: 5px; padding-bottom: 5px"
    >
      <div class="col-lg-4 col-5" style="text-align: center">
        <a routerLink="">
          <img
            id="gcc-logo-agilb2b"
            src="{{ API_IMAGENS }}logo.png"
            class="logomarca img-fluid"
          />
        </a>
      </div>
      <div class="col-lg-4 responsive-header-items">
        <div class="gcc-menu-horizontal">
          <ul>
            <li *ngIf="layoutMenu === 0 || layoutMenu === 5">
              <div
                [ngStyle]="{
                  'text-align': menu && menu.length === 0 ? 'start' : 'center'
                }"
                (mouseenter)="this.dropdown = true && layoutMenu === 0"
                (mouseleave)="this.dropdown = false"
                (click)="this.dropdown = false"
              >
                <a
                  (click)="refreshMenuCatalog()"
                  routerLink="{{ '/catalogo' }}"
                  title="{{ 'catalogo' }}"
                  class="catalogo-link"
                  i18n
                  >Catálogo</a
                >
                <div
                  class="{{
                    this.dropdown && menuDinamico ? '' : 'hide'
                  }} dropdown-treeview"
                  [ngStyle]="{ 'margin-left': '0' }"
                >
                  <app-treeview-link-dynamic
                    (sendFilters)="filtrarPorMenuDinamico($event)"
                    (breadCrumb)="breadCrumbSave($event)"
                  ></app-treeview-link-dynamic>
                </div>
              </div>
            </li>
            <li *ngIf="!menuDinamico">
              <div>
                <a
                  routerLink="{{ '/catalogo' }}"
                  title="{{ 'catalogo' }}"
                  class="catalogo-link"
                  i18n
                  >Catálogo</a
                >
                <div
                  class="{{
                    this.dropdown && menuDinamico ? '' : 'hide'
                  }} dropdown-treeview"
                  [ngStyle]="{ 'margin-left': menu && menu.length === 0 ? '45%' : '0' }"
                >
                  <app-treeview-link-dynamic
                    (sendFilters)="filtrarPorMenuDinamico($event)"
                    (breadCrumb)="breadCrumbSave($event)"
                  ></app-treeview-link-dynamic>
                </div>
              </div>
            </li>
            <li *ngFor="let m of menu">
              <a
                *ngIf="m.link; else elseBlockM"
                (click)="refreshMenu()"
                routerLink="{{ m.link }}"
                title="{{ m.label }}"
                [class.menu-duas-linhas]="m.labelLines"
              >
                <ng-container *ngIf="m.labelLines">
                  <span *ngFor="let linha of m.labelLines" class="menu-duas-linhas-text">{{ linha }}</span>
                </ng-container>
                <ng-container *ngIf="!m.labelLines"  class="menu-duas-linhas-text">{{ m.label }}</ng-container>
              </a>
              <ng-template #elseBlockM>
                <a
                  *ngIf="m.external"
                  target="_blank"
                  (click)="refreshMenu()"
                  href="{{ m.external }}"
                  title="{{ m.label }}"
                  >{{ m.label }}</a
                >
              </ng-template>
              <ul *ngIf="m && m.childs.length > 0">
                <li *ngFor="let m1 of m.childs">
                  <a
                    *ngIf="m1.link; else elseBlockM1"
                    (click)="refreshMenu()"
                    routerLink="{{ m1.link }}"
                    title="{{ m1.label }}"
                    >{{ m1.label }}</a
                  >
                  <ng-template #elseBlockM1>
                    <a
                      *ngIf="m1.external"
                      target="_blank"
                      (click)="refreshMenu()"
                      href="{{ m1.external }}"
                      title="{{ m1.label }}"
                      >{{ m1.label }}</a
                    >
                  </ng-template>
                </li>
              </ul>
            </li>
            <li>
              <!-- <form (submit)="search()">
                <div class="input-group">
                  <input
                    id="searchModalField"
                    type="text"
                    [(ngModel)]="busca"
                    name="busca"
                    class="form-control"
                    i18n
                    placeholder="O que você está procurando?"
                    style="font-size: 1rem !important; height: 36px"
                    aria-label="O que está procurando?"
                  />
                  <div class="input-group-append">
                    <span
                      (click)="search()"
                      (keyup)="search()"
                      class="input-group-text"
                      style="font-size: 1.5rem !important; height: 36px"
                    >
                      <i class="icofont-search"></i>
                    </span>
                  </div>
                </div>
              </form> -->
            </li>
          </ul>
        </div>
      </div>
      <div class="col-2 resp-col"></div>
      <div class="col-lg-4 col-5 d-flex flex-row" style="text-align: center">
        <div class="col-lg-8 col-12 responsive-header-items">
          <form (submit)="search()">
            <div class="input-group">
              <input
                id="searchModalField"
                type="text"
                [(ngModel)]="busca"
                name="busca"
                class="form-control"
                i18n-placeholder="Search"
                placeholder="O que você está procurando?"
                style="font-size: 1rem !important; height: 36px"
                aria-label="O que está procurando?"
              />
              <div class="input-group-append">
                <span
                  (click)="search()"
                  (keyup)="search()"
                  class="input-group-text"
                  style="font-size: 1.5rem !important; height: 36px"
                >
                  <i class="icofont-search"></i>
                </span>
              </div>
            </div>
          </form>
        </div>
        <div class="icons col-lg-4 col-12">
          <div
            *ngIf="securityService.hasToken()"
            class="dropdown pr-3 div-header-menu"
            style="margin-top: 3px"
          >
            <a
              href=""
              class="dropdown-toggle"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="icofont-ui-user"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right div-login-menu"
              style="z-index: 99999999"
              aria-labelledby="dropdownMenuLink"
            >
              <a
                *ngIf="SITE.cliente"
                routerLink="/novo-cliente"
                i18n-routerLink="/new-client"
                class="dropdown-item"
                href="#"
                i18n
                >Novo Cliente</a
              >
              <a routerLink="/meus-dados" i18n-routerLink="/my-data" class="dropdown-item" href="#" i18n
                >Minha conta</a
              >
              <!-- <a
                *ngFor="let nivel of initProvider.usuario.nivel"
                class="dropdown-item new-item"
                href="#"
                routerLink={{nivel.titulo}}
              >
                {{ nivel.titulo }}
              </a> -->
              <a
                *ngIf="checkArrayNivel(initProvider.usuario?.nivel ?? [], 'Historico')"
                routerLink="/Historico"
                i18n-routerLink="/Historical"
                class="dropdown-item new-item"
                href="#"
                i18n
                >Históricos</a
              >
              <a
              *ngIf="checkArrayNivel(initProvider.usuario?.nivel ?? [],  'Cadastro')"
                routerLink="/Cadastro"
                i18n-routerLink="/Register"
                class="dropdown-item new-item"
                href="#"
                i18n
                >Cadastros</a
              >
              <a
              *ngIf="checkArrayNivel(initProvider.usuario?.nivel ?? [],  'Relatorio')"
                routerLink="/Relatorios"
                i18n-routerLink="/Reports"
                class="dropdown-item new-item"
                href="#"
                i18n
                >Relatorios</a
              >
              <a
                href="javascript:void(0);"
                (click)="logout()"
                class="dropdown-item"
                i18n
                >Sair</a
              >
            </div>
          </div>
          <div
            *ngIf="!securityService.hasToken()"
            class="dropdown pr-3 div-header-menu"
            style="margin-top: 3px"
          >
            <a
              href=""
              class="dropdown-toggle"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="icofont-ui-user"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right div-login-menu p-3"
              aria-labelledby="dropdownMenuLink"
              style="width: 260px"
            >
              {{
                SITE && SITE.mensagemLogin
                  ? SITE.mensagemLogin
                  : "pra ver seus pedidos e ter uma experiência personalizada, acesse sua conta :)"
              }}
              <a
                routerLink="/login"
                class="btn text-center dropdown-item mt-3"
                [style.backgroundColor]="backgroundColorSliderSuperior"
                style="color: #ffffff"
                i18n
                >Entrar</a
              >
              <a
                *ngIf="MISC.registroLogin"
                routerLink="/login"
                class="btn text-center dropdown-item mt-2"
                data-toggle="modal"
                data-target="#cadastraModal"
                i18n
                >Cadastrar</a
              >
            </div>
          </div>
          <a
            href="javascript:void(0);"
            data-toggle="modal"
            data-target="#searchModal"
            style="margin-top: 3px"
            class="pr-3 responsive-search"
            (click)="cleanBusca()"
            ><i class="{{ SITE ? SITE.iconSearch : ''}}"></i
          ></a>
          <a
          *ngIf="this.pedido"
            routerLink="/carrinho"
            i18n-routerLink="/cart"
            class="iconcart"
            placement="bottom"
            (mouseenter)="cartShow()"
          >
            <i class="{{ SITE ? SITE.iconCart : ''}}"></i>
            <span class="badge badge-primary">{{ cartTotalItems }}</span>
          </a>
          <a
            href="javascript:void(0);"
            (click)="openNav()"
            class="iconnav pr-3 d-lg-none"
            ><i class="icofont-navigation-menu"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="menuDinamico && layoutMenu !== 0 && layoutMenu < 5"
    class="d-flex flex-row align-items-center responsive-horizontal"
    [style.backgroundColor]="backgroundColor"
    style="min-height: 40px"
  >
    <div
      class="col d-flex flex-row justify-content-center catalog-line align-items-center"
      style="margin-bottom: 0%; display: inline"
    >
      <app-treeview-link-dynamic-horizontal
        (sendFilters)="filtrarPorMenuDinamico($event)"
        (breadCrumb)="breadCrumbSave($event)"
      >
      </app-treeview-link-dynamic-horizontal>
    </div>
  </div>
</div>
<div
  id="myCanvasNav"
  class="overlay"
  (click)="closeOffcanvas()"
  style="width: 0%; opacity: 0"
></div>
<div id="myOffcanvas" class="offcanvas" style="width: 0%">
  <ul class="main-menu">
    <li *ngFor="let m of menu" class="sub-menu">
      <a
        *ngIf="m && m.childs.length; else elseBlockM0"
        href="javascript:void(0);"
        title="{{ m.label }}"
        data-ma-action="submenu-toggle"
        >{{ m.label }}</a
      >
      <ng-template #elseBlockM0
        ><a
          (click)="closeOffcanvas()"
          routerLink="{{ m.link }}"
          title="{{ m.label }}"
          [class.menu-duas-linhas]="m.labelLines"
        >
          <ng-container *ngIf="m.labelLines">
            <span *ngFor="let linha of m.labelLines">{{ linha }}</span>
          </ng-container>
          <ng-container *ngIf="!m.labelLines">{{ m.label }}</ng-container>
        </a></ng-template
      >
      <ul *ngIf="m && m.childs.length">
        <li *ngFor="let m1 of m.childs">
          <a
            (click)="closeOffcanvas()"
            routerLink="{{ m1.link }}"
            title="{{ m1.label }}"
            >{{ m1.label }}</a
          >
        </li>
      </ul>
    </li>
    <li class="sub-menu">
      <a
        routerLink="/catalogo"
        i18n-routerLink="/catalog"
        (click)="closeOffcanvas()"
        data-ma-action="submenu-toggle"
        >Catálogo</a
      >
    </li>
  </ul>
</div>
<div
  class="modal fade"
  id="searchModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="searchModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row mt-3">
          <div class="col-12">
            <form (submit)="search()">
              <div class="input-group mb-4">
                <input
                  #searchInput
                  id="searchModalField"
                  autofocus
                  type="text"
                  [(ngModel)]="busca"
                  name="busca"
                  class="form-control"
                  i18n-placeholder="Search"
                  placeholder="O que você está procurando?"
                  style="font-size: 1.5rem !important"
                  aria-label="O que está procurando?"
                />
                <div class="input-group-append">
                  <span
                    (click)="search()"
                    class="input-group-text"
                    style="font-size: 1.5rem !important"
                  >
                    <i class="icofont-search"></i>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <!-- Mostra o Carrinho Flutuante - Descomentar após fazer parametro -->
  <div
    style="z-index: 99999999"
    *ngIf="mostraCarrinhoConfig && pedido && pedido.itens.length && showCart"
    appMoveOutside
    (moveOutside)="cartFadeOut()"
    appClickOutside
    (clickOutside)="cartOut()"
    (mouseenter)="cartShow()"
    [class]="cartClass"
  >
    <app-cart
      (showCart)="this.fadeOutForbidden = true"
      (hideCart)="cartOut()"
      *ngIf="pedido"
    >
    </app-cart>
  </div>

  <div
    class="modal fade"
    id="cadastraModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="cadastraModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" i18n>Cadastro</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="p-2 pb-3">
          <novo-cliente
            [registro]="true"
            [cadastroCliente]="true"
          ></novo-cliente>
        </div>
      </div>
    </div>
  </div>
</div>
